module.exports = __webpack_public_path__ + "img/icon_carIn.31e64144.png";